parseDirectiveLocations